import Picklists from './Picklists'

export default Picklists



// WEBPACK FOOTER //
// ./src/components/Reports/Shellfish/Picklists/index.js